import { Grid, Typography, Zoom } from "@mui/material"
import React, { useContext, useMemo, useState } from "react"
import { CustomBottomNavigation } from "../../../../../../components/buttons/navigate-button/CustomBottomNavigation"
import { BSVariantCard } from "../../../../../../components/card/beem-shot/BSVariantCard"
import { SearchAndFilter } from "../../../../../../components/FilterListDrawer/SearchAndFilter"
import { BSVariant } from "../../../../../../core/dto/beem-shot/BSVariant/BSVariant"
import { CreateVariantDialogContext } from "../BSVariantFormDialog/CreateVariantDialogContext"

interface IProps {
  bsVariants: BSVariant[]
}

export function BSVariantList({ bsVariants }: Readonly<IProps>): React.JSX.Element {
  const { handleOpen } = useContext(CreateVariantDialogContext)

  const [searchValue, setSearchValue] = useState<string>("")

  const bsVariantsToShow = useMemo(() => {
    const list = bsVariants
    if (searchValue !== "") {
      return list.filter((variant) => variant.name.toLowerCase().includes(searchValue.toLowerCase()))
    }
    return list
  }, [bsVariants, searchValue])

  function handleSearch(newSearchState: string): void {
    setSearchValue(newSearchState)
  }

  return (
    <>
      <Grid item xs={5}>
        <SearchAndFilter
          searchStateLabel="Rechercher par nom"
          searchState={searchValue}
          handleSearch={handleSearch}
          isFilterDrawer={false}
        />
      </Grid>
      <Grid item xs={12} container>
        {bsVariantsToShow.length > 0 ? (
          bsVariantsToShow.map((bsVariant: BSVariant, index) => (
            <Zoom in style={{ transitionDelay: `${index * 80}ms` }} key={bsVariant.id}>
              <Grid item xs={12} lg={4} xl={3} key={bsVariant.id} p={1}>
                <BSVariantCard bsVariant={bsVariant} />
              </Grid>
            </Zoom>
          ))
        ) : (
          <Typography>Pas de résultats...</Typography>
        )}
      </Grid>

      <CustomBottomNavigation actionLabel="Créer une estimation" validateAction={handleOpen} />
    </>
  )
}
